// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__MOl6F","footer":"ModalCreateQualiphyProcedure_footer__KWk1T","additionData":"ModalCreateQualiphyProcedure_additionData__1w-4i"};